import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase/firebaseConfig";

const MemberAtt = () => {
    const [email, setEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const setAttendance = async(e) => {
        e.target.innerHTML = "Submitting...";

        const querySnapshot = await getDocs(collection(db, `Members`));
        const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const date = new Date();

        for (let i = 0; i < documents.length; i++) {
            if (documents[i].Email === email) {
                await updateDoc(doc(db, `Members/${documents[i].id}`), {
                    Attendance: date, 
                });
            }
        }

        setSubmitted(true);
    }

    return (
        <div id="content">
            <div className='row'>
                <h1>RCC Attendance</h1>
                <h2 className='ev-sub-title'>Revival Church Montana</h2>
            </div>
            <br/>
            <br/>
            {!submitted ? (
            <div className='row'>
                <label>Email Address:<input type="email" onChange={(e) => setEmail(e.target.value)}/></label>
                <button style={{marginTop: "30px"}} onClick={(e) => setAttendance(e)}>Submit</button>
            </div>
            ) : (
                <div className='row'>
                <h4>Thank You for Attending RCC Montana</h4>
                <p>Enjoy the service!</p>
                </div>
            )
            }
        </div>
    )
}

export default MemberAtt; 